import { environment } from './environment';

export function isDeployedToDev(): boolean {
  return environment.deployedEnv === 'Development';
}
export function isDeployedToUAT(): boolean {
  return environment.deployedEnv === 'UAT';
}
export function isDeployedToStage(): boolean {
  return environment.deployedEnv === 'Staging';
}
export function isDeployedToProd(): boolean {
  return environment.deployedEnv === 'Production';
}
